const checkContinuePeriod = (dates) => {
    const last_date = new Date(dates[dates.length-1].timestamp);
    const first_date = new Date(dates[0].timestamp);
    return (last_date-first_date)/ (1000 * 60 * 60 * 24)>dates.length;
};

export { checkContinuePeriod };